import React from 'react';
import {Grid, Typography, Box, Chip, useTheme} from "@mui/material";
import {NbaGame} from "../../../../../../../types/cbbTypes";

interface TrendTypeSelectorProps {
    currentMatchup?: NbaGame;
    trendTypes?: string[];
    playoffTrendTypes?: string[];
    trendType: string;
    setTrendType: (trendType: string) => void;
    mt?: number;
}

export const TrendTypeSelector = (
    {
        currentMatchup,
        trendTypes = [],
        playoffTrendTypes = [],
        trendType,
        setTrendType,
        mt,
    }: TrendTypeSelectorProps) => {

    const theme = useTheme()

    const getStreakChip = (label: string, index: number) => {
        const variantToUse = trendType === label ? 'filled' : 'outlined';
        return (
            <Chip
                key={index}
                size="small"
                color="primary"
                variant={variantToUse}
                onClick={() => setTrendType(label)}
                label={label}
                style={{marginRight: '4px', marginBottom: '4px'}}
            />
        );
    };

    if (currentMatchup?.playoffs?.toString() === '1') {
        trendTypes?.push('playoffs');
    }

    return (
        <Grid
            item
            md={12}
            xs={12}
            mt={mt}
            mb={1}
            container
            display="flex"
            flexDirection="column"
            alignContent="center"
        >
            <Box
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    alignContent: 'center',
                }}
            >
                <Typography
                    component="p"
                    display="flex"
                    alignContent="center"
                    variant="caption"
                    align="center"
                    color={theme.palette.grey[500]}
                    mr={1}
                >
                    Parameters:
                </Typography>
                {trendTypes.map((type: string, index: number) =>
                    getStreakChip(type, index)
                )}
            </Box>
            {playoffTrendTypes.length ?
                <Box
                    display="flex"
                    flexWrap="wrap"
                    justifyContent="center"
                    mt={1}
                >
                    <Typography
                        component="p"
                        display="flex"
                        alignContent="center"
                        alignSelf="center"
                        variant="caption"
                        align="center"
                        color={theme.palette.grey[500]}
                        mr={1}
                    >
                        Playoff Parameters:
                    </Typography>
                    {playoffTrendTypes.map((type: string, index: number) =>
                        getStreakChip(type, index)
                    )}
                </Box> : ''
            }

        </Grid>
    );
};
